<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDependente" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioDependente.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioDependente.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Nasc.</mat-label>
                            <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                id="dataNascimento" name="dataNascimento">
                            <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataNascimentoDP></mat-datepicker>

                            <mat-error *ngIf="formularioDependente.controls.dataNascimento.hasError('required')">
                                O campo Data Nasc. é obrigatório.
                            </mat-error>

                            <mat-error *ngIf="formularioDependente.controls.dataNascimento.hasError('invalidDate')">
                                O campo Data Nasc. está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioDependente.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>